meedy.controller('meedy.popupCalendarTermConflictsController', ['$scope', '$state', '$mdDialog', 'terms', 'message', 'termWrapper', 'meedy.termModel', 'applicationModel',
    function ($scope, $state, $mdDialog, terms, message, termWrapper, termModel, applicationModel) {

        function setData() {
            $scope.terms = terms;

            $scope.title = 'T.MEEDY.DATA.ALERT';
            $scope.message = message;
            $scope.yesText = 'T.MEEDY.UI.APPLICATION.CONTINUE';
            $scope.noText = 'T.MEEDY.UI.APPLICATION.BACK';

            $scope.appointment = termWrapper.appointment;
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });
        }

        function setActions() {
            $scope.ok = function() {

                if(termWrapper.action == Constant.MEEDY.DIALOG_EVENT.TERM.CREATE) {

                    termModel.createTerm($scope.appointment);

                    var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();

                        var createdTerm = result;
                        $mdDialog.hide(createdTerm);

                        //Do przeładowania widoku kalendarza (przypadek popup od popupa do popupa)
                        $state.go($state.current, {}, {reload: true});
                    });

                    var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                    });
                } else if(termWrapper.action == Constant.MEEDY.DIALOG_EVENT.TERM.EDIT) {

                    termModel.updateTerm($scope.appointment);

                    var successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();

                        var updatedTerm = result;
                        $mdDialog.hide(updatedTerm);
                        //Do przeładowania widoku kalendarza (przypadek popup od popupa do popupa)
                        $state.go($state.current, {}, {reload: true});
                    });

                    var errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.loading = false;
                    });
                }

            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.back = function() {

                if(termWrapper.action == Constant.MEEDY.DIALOG_EVENT.TERM.CREATE) {

                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-create-popup.html',
                        controller: 'meedy.popupCalendarTermCreateController',
                        resolve: {
                            date: function () {
                                return termWrapper.date;
                            },
                            resource: function () {
                                return termWrapper.resourceToUse;
                            },
                            termWrapper: function () {
                                return termWrapper;
                            }
                        }
                    }).then(function (newTerm) {

                    }, function (error) {
                    });

                } else if(termWrapper.action == Constant.MEEDY.DIALOG_EVENT.TERM.EDIT) {

                    $mdDialog.show({
                        templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-edit-popup.html',
                        controller: 'meedy.popupCalendarTermEditController',
                        resolve: {
                            term: function() {
                                return termWrapper.term;
                            },
                            termWrapper: function() {
                                return termWrapper;
                            }
                        }
                    }).then(function(editedTerm) {

                    }, function() {
                    });
                }

                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);